import { Link } from "react-router-dom";
import styled from "styled-components/macro";
import type { ElearningTheme } from "themes/elearning.theme";

interface Props {
  theme: ElearningTheme;
}

export const StyleContainer = styled.div<Props>`
display: flex;
flex-direction: column;
margin-bottom: 10px;
padding-bottom: 10px;
width: 100%;
align-items: center;
justify-content: center;
`;

export const StyleBreadcrumbsContainer = styled.div<Props>`
display: flex;
flex-direction: row;
align-items: center;
justify-content: space-between;
width: 100%;
height: 45px;
box-shadow: 0 0 7px 1px ${(props: Props) => props.theme.palette.neutral._400};
ul {
  margin: 10px 0px;
}
`;

export const StyleHeading4 = styled.p<Props>`
font-weight: 900;
`;

export const TitleContainer = styled.div<Props>`
display: flex;
align-items: center;
justify-content: center;
margin-bottom: 2px;
`;

export const BackButton = styled(Link)<Props>`
margin-left: 20px;
cursor: pointer;
display: flex;
align-items: center;
justify-content: center;
text-decoration: none;
`;

export const StyleButtonText = styled.p<Props>`
color: ${(props: Props) => props.theme.palette.neutral._80};
`;

export const StyleProgressContainer = styled.div<Props>`
position: fixed;
bottom: 0;
left: 0;
right: 0;
width: 100%;
box-shadow: 0 0 4px 0 rgb(0 0 0 / 20%);
height: 72px;
background-color: #fff;
`;

export const StyleTestContainer = styled.div<Props>`
margin-bottom: 75px;
width: 100%;
`;

export const StyleTestIntro = styled.div<Props>`
margin: 20px auto 0;
max-width: 768px;
padding: 0 8px;
`;
